import React, { useContext } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
	const { isAuth, loading } = useContext(AuthContext);

	/** Enquanto a sessão está sendo restaurada (F5), não redireciona para login. */
	if (isPrivate) {
		if (loading) {
			return <BackdropLoading />;
		}
		if (!isAuth) {
			return (
				<Redirect
					to={{ pathname: "/login", state: { from: rest.location } }}
				/>
			);
		}
		return <RouterRoute {...rest} component={Component} />;
	}

	/** Login/signup: só manda para a home depois que o refresh terminou. */
	if (isAuth && !isPrivate && !loading) {
		return (
			<Redirect to={{ pathname: "/", state: { from: rest.location } }} />
		);
	}

	return (
		<>
			{loading && <BackdropLoading />}
			<RouterRoute {...rest} component={Component} />
		</>
	);
};

export default Route;
